import React from 'react';
import ReactDOM from 'react-dom';
import { CheckCircle } from 'lucide-react';
import './ConfirmDialog.scss';

interface ConfirmDialogProps {
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  message,
  confirmText = 'OK',
  cancelText = 'Cancel',
  onConfirm,
  onCancel
}) => {
  const content = (
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-icon">
          <CheckCircle size={80} />
        </div>
        <div className="confirm-dialog-message">
          {typeof message === 'string' ? <p>{message}</p> : message}
        </div>
        <div className="confirm-dialog-actions">
          <button className="btn-ok" onClick={onConfirm}>
            {confirmText}
          </button>
          <button className="btn-cancel" onClick={onCancel}>
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
};

export default ConfirmDialog;

